import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class MenuBottomAddContentService {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.menuChanged = new BehaviorSubject(false);
    }
    show() {
        this.menuChanged.next(true);
    }
    hide() {
        this.menuChanged.next(false);
    }
    toggle() {
        this.menuChanged.next(!this.menuChanged.value);
    }
}
MenuBottomAddContentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenuBottomAddContentService_Factory() { return new MenuBottomAddContentService(i0.ɵɵinject(i0.NgZone)); }, token: MenuBottomAddContentService, providedIn: "root" });
